import { useQuery } from '@tanstack/react-query';
import { wordpressApi } from '../api/wordpress';

export function useWordpressSummary() {
  return useQuery({
    queryKey: ['wordpress', 'summary'],
    queryFn: wordpressApi.getSummary,
    refetchInterval: 60_000,
    staleTime: 30_000,
    retry: false,
  });
}
